// Runtime endpoints. The API URL is stable across deploys (the HTTP API keeps
// its id); everything else the admin screen needs is fetched from /admin/config.
export const API_BASE = 'https://xczjqb3x9i.execute-api.eu-west-1.amazonaws.com';
